module.exports = __webpack_public_path__ + "static/media/inspiron_poster.73b36fd3.jpeg";